import type { AdUnit } from '../../Entities/AdUnit.entity';
import { PATH_BASE } from '../Constants';
import { MPU_SIZE } from '../UnitSizes';

export const DesktopSMMPU2 = {
  path: `${PATH_BASE}/MPU2_UK`,
  sizes: [MPU_SIZE],
  defaultHeight: MPU_SIZE[1],
  maxWidth: 960,
  minHeight: 250,
  responsiveSizeMap: {
    1440: [],
    1280: [MPU_SIZE],
    1024: [MPU_SIZE],
    768: [],
    0: [],
  },
  useSizeMap: true,
  trackingData: {
    renderEvent: {
      name: 'UK_webapp_slot_render_ended',
      label: 'MPU 2 UK banner is loaded',
    },
    impressionEvent: {
      name: 'UK_webapp_impression_viewable',
      label: 'MPU 2 UK banner is loaded',
    },
  },
} as const satisfies AdUnit;
